import {useNavigate} from 'react-router-dom';

import {AiOutlineEdit} from 'react-icons/ai';
import {FlexiButton, FlexiCancelButton} from '@flexinet/ui-components';
import {useVerifiedPermissions} from '../../../hooks/useVerifiedPermissions.ts';
import {rbacActions} from '../../../config/rbac/actions.ts';

export const useEditPageTools = ({onEdit}: { onEdit: () => void }) => {

    const navigate = useNavigate();
    const {allowedActions} = useVerifiedPermissions();

    const tools = [];

    if (allowedActions.includes(rbacActions.UpdateInvoice)) {
        tools.push(
            <FlexiButton leftSection={<AiOutlineEdit/>} variant={'filled'} key={'edit'} onClick={onEdit}>
                Edit
            </FlexiButton>,
        );
    }

    tools.push(<FlexiCancelButton key={'close'} onClick={() => navigate(`/invoices`)}/>);

    return {tools};
};
